import { useLanguage } from "@/app/utils/LanguageContext";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const TipsWrapper = styled.div`
  z-index: 1001;
  position: absolute;
  right: 0;
  top: 46px;
  display: flex;
  flex-direction: column;

  &.tip1{
    top: 145px;
  }
`;
const TipsPart1 = styled.div`
  width: 8.11px;
  height: 8.11px;
  background: rgba(27, 59, 140, 1);
  transform: rotate(-45deg);
  align-self: flex-end;
  margin-right: 18px;
  margin-bottom: -4.1px;
`;
const TipsPart2 = styled.div`
  padding: 12px;
  min-width: 240px;
  background: rgba(27, 59, 140, 1);
  border-radius: 12px;
`;
const TipsConent = styled.p`
  width: 80%;
  font-size: 16px;
  font-weight: 500;
  color: white;
  text-align: left;
`;
const TipsAction = styled.p`
  margin-top: 12px;
  width: 100%;
  font-size: 13px;
  font-weight: 700;
  color: white;
  text-align: right;
  display: flex;
  justify-content: end;
`;
const TipsConfirm = styled.div`
  width: fit-content;
`;
const OverLay = styled.div`
  z-index: 1000;
  position: fixed;
  inset: 0px;
  background-color: transparent;
`;

interface Props {
  isPositionLeft?: boolean;
  localStoragekey: string;
  message: string;
  onDisplay?: () => void; // override default display logic
  onDismiss?: () => void; // additional action on dismissing tooltip
}

const Tips = ({ localStoragekey, message, onDisplay, onDismiss, isPositionLeft }: Props) => {
  const [showTip, setShowTip] = useState(false);
  const { state: lang } = useLanguage();
  const { t } = lang;
  const ref = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const isTipDismissed = JSON.parse(localStorage.getItem('tipDismissed')||'{}')[localStoragekey];
    if (!isTipDismissed) {
      setShowTip(true);
    }
  }, [localStoragekey]);

  // event on displaying tooltip
  useEffect(() => {
    if (ref.current && showTip) {
      if (onDisplay) {
        onDisplay();
      } else {
        ref.current.parentElement?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [showTip, ref.current]);

  // event on dismissing tooltip
  const handleGotTIt = () => {
    setShowTip(false);
    const tipDismissed = JSON.parse(localStorage.getItem('tipDismissed')||'{}');
    tipDismissed[localStoragekey] = true;
    localStorage.setItem('tipDismissed', JSON.stringify(tipDismissed));
    if (onDismiss) {
      onDismiss();
    }
  };

  if (!showTip) return null;
  return (
    <>
      <OverLay />
      <TipsWrapper ref={ref} className={`tipWrapper ${localStoragekey}`} onClick={(e:any)=>e.stopPropagation()} 
      style={{left: isPositionLeft ? "0" : "unset", right: isPositionLeft ? "unset" : "0"}}>
        <TipsPart1 style={{alignSelf: isPositionLeft ? "center" : "flex-end"}} />
        <TipsPart2>
          <TipsConent>{message}</TipsConent>
          <TipsAction>
            <TipsConfirm onClick={handleGotTIt}>{t("got_it")}</TipsConfirm>
          </TipsAction>
        </TipsPart2>
      </TipsWrapper>
    </>
  );
};
export default Tips;
